<template>
  <validator name="subscribeValidator">
    <form v-el:payment id="payment-form" method="POST" action="/charge" novalidate>
      <div v-show="trial" class="mdl-card fill">
        <div class="panel__content">
          <div class="form-row">
            <span>
              {{ 'payment.label.trial.description'| label }}
            </span>
          </div>
          <div class="mdl-card__actions">
            <div class="mdl-grid inner-grid">
              <div class="mdl-cell mdl-cell--12-col">
                <div class="mdl-button mdl-js-button mdl-button--raised mdl-button--colored fill"
                  v-on:click="activateTrial()">
                  {{'payment.button.trial' | label}}
                </div>
              </div>
            </div>
          </div>            
        </div>
      </div>
      <div v-show="!trial && payload && payload.billingPeriod">
        <div class="mdl-card fill">
          <div class="panel__content">
            <div class="form-row">
              <!--<label for="card-element">-->
                <!--Credit or debit card-->
              <!--</label>-->
              <div class="textfield--float-label">
                <label class="StripeElement--label ga-required" for="cardNumber-element">
                <span class="icon">
                  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24"><path d="M0 0h24v24H0z" fill="none"/><path fill="#52757a" d="M20 4H4c-1.11 0-1.99.89-1.99 2L2 18c0 1.11.89 2 2 2h16c1.11 0 2-.89 2-2V6c0-1.11-.89-2-2-2zm0 14H4v-6h16v6zm0-10H4V6h16v2z"/></svg>
                </span>
                  {{ 'payment.label.cardnumber' | label}}
                <div id="cardNumber-element">
                  <!-- a Stripe Element will be inserted here. -->
                </div>
                </label>
              </div>
              <div class="textfield--float-label">
                <label class="StripeElement--label" for="cardExpiry-element">
                <span class="icon">
                  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24"><path fill="#52757a" d="M9 11H7v2h2v-2zm4 0h-2v2h2v-2zm4 0h-2v2h2v-2zm2-7h-1V2h-2v2H8V2H6v2H5c-1.11 0-1.99.9-1.99 2L3 20c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 16H5V9h14v11z"/></svg>
                </span>
                  {{ 'payment.label.expiration'  | label}}
                </label>
                <div id="cardExpiry-element">
                  <!-- a Stripe Element will be inserted here. -->
                </div>
              </div>
              <div class="textfield--float-label">
                <label class="StripeElement--label" for="cardCvc-element">
                <span class="icon">
                  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24"><path fill="#52757a" d="M18 8h-1V6c0-2.76-2.24-5-5-5S7 3.24 7 6v2H6c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V10c0-1.1-.9-2-2-2zm-6 9c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2zm3.1-9H8.9V6c0-1.71 1.39-3.1 3.1-3.1 1.71 0 3.1 1.39 3.1 3.1v2z"/></svg>
                </span>
                  {{ 'payment.label.cvv' | label}}
                </label>
                <div id="cardCvc-element">
                  <!-- a Stripe Element will be inserted here. -->
                </div>
              </div>
              <!-- Used to display form errors -->
              <div v-if="err" class="form-validation-error">
                <span>{{ err.message | label }}</span>
              </div>
            </div>
            <!--<button>Submit Payment</button>-->
          </div>
          <div class="mdl-card__actions">
            <div class="mdl-grid inner-grid">
              <div class="mdl-cell mdl-cell--12-col">
                <div class="mdl-button mdl-js-button mdl-button--raised mdl-button--colored fill"
                  v-on:click="pay()">
                  {{'payment.button.pay' | label}}
                </div>
              </div>
              <div class="mdl-cell mdl-cell--12-col" v-if="payload.user">
                <div class="mdl-button mdl-js-button mdl-button--raised fill bitcoin-button"
                    v-on:click.prevent="coinPayments">
                  <img src="/static/img/buynow-ani-transparent.png" height="100%">
                  {{'payment.button.bitcoin' | label}}
                </div>
              </div>
              <div class="mdl-cell mdl-cell--12-col" id="paypal-button-container">
              </div>              
            </div>
          </div>
        </div>
      </div>
    </form>
    <form v-show="false" action="https://www.coinpayments.net/index.php" method="post" target="_blank" v-el:coinpaymentsform>
        <input name="cmd" value="_pay_simple">
        <input name="reset" value="1">
        <input name="ipn_url" :value="cryptoPaymentOptions.urlIPN">
        <input name="merchant" :value="cryptoPaymentOptions.merchantId">
        <input name="currency" :value="cryptoPaymentOptions.currency1">
        <input name="amountf" :value="cryptoPaymentOptions.sandbox ? 1 : payload.pricing">
        <input name="item_name" :value="payload.itemLabel | label">	
        <input name="first_name" :value="payload.user.firstName || payload.user.nickname">
        <input name="last_name" :value="payload.user.lastName">
        <input name="email" :value="payload.user.email">
        <input name="on1" value="userId">
        <input name="ov1" :value="payload.user.id">
        <input name="item_number" :value="payload.billingPeriod">
        <input name="custom" :value="cryptoPaymentOptions.transactionId">
        <input name="success_url" :value="result_url+'?success=true'">
        <input name="cancel_url" :value="result_url">
    </form>
  </validator>
</template>

<script>
  var api = require('api')
  var payment = require('api/Payment')
  var config = require('common/config')
  var actions = require('common/store/actions')
  var getters = require('common/store/getters')

  module.exports = {
    props: {
      payload: Object
    },
    ready: function () {
      this.setupPaypal()
      window.componentHandler.upgradeAllRegistered()
      this.setupStripe()
      this.setupCoinPayments()
    },
    vuex: {
      getters: getters,
      actions: actions
    },
    events: {
      'payment-token': function (token) {
        this.$dispatch('loading', false)
      },
      'billing-period-changed': function (payload) {
        this.payload = payload
      }
    },
    methods: {
      change: function (event) {
        // Handle real-time validation errors from the card Element.
        this.err = null
        if (event.error) {
          this.onError(event.error)
        }
      },
      setupStripe: function () {
        this.stripe = window.Stripe(config.stripe.pk)

// Create an instance of Elements
        this.elements = this.stripe.elements({style: this.paymentForm})
        this.cardNumber = this.elements.create('cardNumber').on('change', this.change)
        this.cardExpiry = this.elements.create('cardExpiry').on('change', this.change)
        this.cardCvc = this.elements.create('cardCvc').on('change', this.change)

        // Add an instance of the card Element into the `card-element` <div>
        this.cardNumber.mount('#cardNumber-element')
        this.cardExpiry.mount('#cardExpiry-element')
        this.cardCvc.mount('#cardCvc-element')
        this.$dispatch('loading', false)
      },
      setupPaypal: function () {
        var self = this
        var tokenUrl = config.apiHost + '/paypal/token'
        var checkoutUrl = config.apiHost + '/paypal/checkout'
        window.paypal.Button.render({
          // Set your environment
          env: config.paypal.env, // sandbox | production
          // Specify the style of the button
          style: config.paypal.style,
          client: config.paypal.client,
          payment: function (actions) {
            // Make a client-side call to the REST api to create the payment
            self.err = null
            return window.paypal.request.post(tokenUrl, self.payload).then(function (res) {
              return res.id
            }, self.onError)
          },
          onAuthorize: function (data, actions) {
            data.userId = self.payload.userId
            data.billingPeriod = self.payload.billingPeriod
            data.service = self.payload.service
            return window.paypal.request.post(checkoutUrl, data).then(function (res) {
              self.$dispatch('paypal-success', res)
            }).catch(function (error) {
              console.log(error)
              self.onError({type: 'paypal', code: 'paypal_general'})
            })
          }

        }, '#paypal-button-container')
        this.$dispatch('loading', false)
      },
      setupValidation: function (err, fields) {
        if (err) {
          return this.onError(err)
        }
        this.hostedFields = fields
        this.$dispatch('loading', false)
      },
      // Step 1.1: User pay with credit card
      pay: function () {
        var self = this
        self.err = null
        self.$dispatch('loading', true)
        var data = {
          billingPeriod: self.payload.billingPeriod,
          serviceCode: self.payload.service,
          serviceIsTrial: self.payload.trial
        }
        // Request to server to initialize a payment intent
        api.$http.post(api.$host + '/payment/startPayment', data).then(res => {
          self.confirmPayment(res.data)
        }).catch(err => {
          self.$dispatch('loading', false)
          console.error('stripe payment step 1:', err)
        })
      },
      activateTrial: function () {
        var self = this
        self.$dispatch('payload', self.payload)
      },
      // Step 2: Collect payment details on the client side
      confirmPayment (data) {
        var self = this
        self.stripe.confirmCardPayment(
          data.client_secret,
          {
            payment_method: {card: self.cardNumber}
          }
        ).then(function (payload) {
          self.$dispatch('loading', false)
          if (payload.error) {
            return self.onError(payload.error)
          } else {
            self.$dispatch('payload', payload)
          }
        })
      },
      paypal: function () {
        return window.paypal.request.post(config.apiHost + '/paypal/token', {
          billingPeriod: self.billingPeriod,
          service: self.service.code
        }).then(function (res) {
          return res.payToken
        })
      },
      onError: function (err) {
        if (!err.type) {
          this.err = err
          return
        }
        switch (err.code) {
          case 'incorrect_number':
            this.err = { message: 'payment.stripe.error.incorrect_number' }
            break
          case 'invalid_number':
            this.err = { message: 'payment.stripe.error.invalid_number' }
            break
          case 'invalid_expiry_month':
            this.err = { message: 'payment.stripe.error.invalid_expiry_month' }
            break
          case 'invalid_expiry_year':
            this.err = { message: 'payment.stripe.error.invalid_expiry_year' }
            break
          case 'invalid_cvc':
            this.err = { message: 'payment.stripe.error.invalid_cvc' }
            break
          case 'expired_card':
            this.err = { message: 'payment.stripe.error.expired_card' }
            break
          case 'incorrect_cvc':
            this.err = { message: 'payment.stripe.error.incorrect_cvc' }
            break
          case 'incorrect_zip':
            this.err = { message: 'payment.stripe.error.incorrect_zip' }
            break
          case 'card_declined':
            this.err = { message: 'payment.stripe.error.card_declined' }
            break
          case 'missing':
            this.err = { message: 'payment.stripe.error.missing' }
            break
          case 'processing_error':
            this.err = { message: 'payment.stripe.error.processing_error' }
            break
          case 'rate_limit':
            this.err = { message: 'payment.stripe.error.rate_limit' }
            break
          case 'paypal_general':
            this.err = {message: 'payment.error.paypal.failed'}
            break
          default:
            this.err = { message: 'payment.error.unknown' }
        }
        this.$dispatch('loading', false)
      },
      setupCoinPayments: function () {
        payment.getCoinPaymentsInfo().then((response) => {
          const coinPaymentsInfo = response.data
          this.cryptoPaymentOptions = coinPaymentsInfo
        })
      },
      coinPayments: function () {
        console.log('coinPayments...')
        this.cryptoPaymentOptions.transactionId = null
        const data = {}
        data.userId = this.payload.user.id
        data.service = this.payload.service
        data.billingPeriod = this.payload.billingPeriod
        this.$els.coinpaymentsform.submit()
        // payment.getCoinPaymentsCheckout(data).then(transactionId => {
        //   this.cryptoPaymentOptions.transactionId = transactionId
        // })
      }
    },
    computed: {
      trial: function () {
        return this.payload.trial
      },
      result_url: function () {
        return config.clientHost + '/app/cryptopaymentresult'
      }
    },
    data: function () {
      return {
        err: null,
        paypalInstance: {},
        hostedFields: {},
        paymentForm: {
          base: {
            'font-size': '16px',
            'font-family': 'roboto, verdana, sans-serif',
            'font-weight': 'lighter',
            'color': 'gray'
          }
        },
        cryptoPaymentOptions: {
          merchantId: '',
          currency1: '',
          transactionId: null
        }
      }
    }
  }
</script>

<style scoped>

.form-validation-error {
    color: red;
}

/*--------------------
SHARED VARIABLES
--------------------*/
/*--------------------
GENERAL
--------------------*/
*,
*:before,
*:after {
box-sizing: inherit;
}

html {
box-sizing: border-box;
height: 100%;
overflow: hidden;
}

body {
background: #f2f2f2;
font-family: 'Roboto', verdana, sans-serif;
height: 100%;
}

h1 {
font-size: 1.5em;
font-weight: 100;
}

#cardForm {
height: 100%;
display: flex;
justify-content: center;
align-items: center;
}

/*--------------------
PANEL FORM
--------------------*/
.panel {
background: #FFF;
width: 80%;
box-shadow: 0 2px 2px 0 rgba(0, 0, 0, 0.16), 0 0 2px 0 rgba(0, 0, 0, 0.12);
}

.panel__header {
background: #52757a;
color: #FFF;
}

.panel__header,
.panel__footer {
padding: 1em 2em;
}

.panel__footer {
background: #f3f3f3;
}

.panel__content {
padding: 1em 2em;
overflow: hidden;
}

.textfield--float-label {
width: 100%;
float: left;
display: inline-block;
}

.StripeElement--label {
transform: translateY(0.4em);
font-size: 1em;
line-height: 32px;
transition: all .15s ease-out;
display: block;
width: 100%;
font-weight: 400;
overflow: hidden;
margin-bottom: 0.5em;
color: gray;
}
.StripeElement--label.label-float, .StripeElement--label.filled, .StripeElement--label.invalid {
height: 33px;
margin-bottom: -1px;
transform: translate(0, 0);
font-size: 12px;
line-height: 15px;
text-overflow: ellipsis;
color: #52757a;
transition: all 0.15s ease-out;
}
.StripeElement--label.filled {
color: rgba(0, 0, 0, 0.54);
}
.StripeElement--label.invalid {
color: #F44336;
}

span.icon {
position: relative;
margin-right: 0.2em;
}

svg {
fill: #555;
}

.StripeElement {
height: 32px;
margin-bottom: 1em;
display: block;
background-color: transparent;
color: rgba(0, 0, 0, 0.87);
border: none;
border-bottom: 1px solid rgba(0, 0, 0, 0.26);
outline: 0;
width: 100%;
font-size: 16px;
padding: 0;
box-shadow: none;
border-radius: 0;
position: relative;
}

.pay-button {
background: #E91E63;
color: #fff;
margin: 0 auto;
border: 0;
border-radius: 3px;
padding: 1em 3em;
font-size: 1em;
text-transform: uppercase;
box-shadow: 0 0 2px rgba(0, 0, 0, 0.12), 0 2px 2px rgba(0, 0, 0, 0.2);
}

/*--------------------
BT HOSTED FIELDS SPECIFIC
--------------------*/
.StripeElement--focus {
border-bottom: 2px solid #F9A01B;
transition: all 200ms ease;
}

.StripeElement--invalid {
border-bottom: 2px solid #E91E63;
transition: all 200ms ease;
}

/*---------------------
Media Queries
----------------------*/
@media (max-width: 600px) {
html {
  overflow: auto;
}

#paymentForm {
  height: auto;
  margin: 2em;
  font-size: 13px;
}

.panel {
  width: 100%;
}

.textfield--float-label {
  width: 100%;
  float: none;
  display: inline-block;
}

.pay-button {
  width: 100%;
}
}

</style>



// WEBPACK FOOTER //
// SubscribeForm.vue?3427b49a